<template>
  <section class="text-gray-600 body-font">
    <div class="bg-blue-200">
      <img
        class="h-20 sm:h-40 p-2 bg-gray-700"
        src="https://fanart.tv/fanart/movies/1402/hdmovielogo/the-pursuit-of-happyness-59fcc2049b722.png"
      />
      <div
          class="w-10 h-5 text-xs sm:w-20 sm:h-10 sm:p-2 sm:text-lg text-center rounded-md bg-gray-700 text-white float-right"
        >
          <a href="#faq">FAQs</a>
        </div>
    </div>
    <div class="container px-5 py-10 mx-auto flex flex-col">
      <div class="mb-10 font-bold text-4xl font-sans position-absolute">
        The Pursuit of Happyness
        <h2 class="font-small font-mono title-font mt-4 text-gray-900 text-sm">
          PG-13 | 1h 57min | Biography, Drama | 15 December 2006 (USA)
        </h2>
      </div>
      <div class="lg:w-4/6 mx-auto">
        <div class="rounded-lg h-64 overflow-hidden">
          <img
            alt="content"
            class="object-cover object-center h-full w-full"
            src="https://i.ytimg.com/vi/DUf5f9TlEr0/maxresdefault.jpg"
          />
        </div>
        <div class="flex flex-col sm:flex-row mt-10">
          <div class="sm:w-1/3 text-center sm:pr-8 sm:py-8">
            <div
              class="rounded-full inline-flex items-center justify-center bg-gray-200 text-gray-400"
            >
              <img
                class="w-20 h-20 rounded-full object-cover"
                src="https://d2e111jq13me73.cloudfront.net/sites/default/files/styles/share_link_image_large/public/screenshots/csm-movie/the-pursuit-of-happyness-ss1.jpg?itok=EWqP05Qm"
              />
            </div>
            <div class="flex flex-col items-center text-center justify-center">
              <h2 class="font-medium title-font mt-4 text-gray-900 text-lg">
                The Pursuit of Happyness
              </h2>
              <h2 class="font-mono title-font text-gray-900 text-sm">
                <a
                  href="https://www.imdb.com/title/tt0454921/"
                  class="hover:text-blue-500"
                  >IMDb</a
                >
                8.0/10
              </h2>
              <div class="w-12 h-1 bg-indigo-500 rounded mt-2 mb-4"></div>
              <p class="text-base">
                A struggling salesman takes custody of his son as he's poised to
                begin a life-changing professional career.
              </p>
            </div>
          </div>
          <div
            class="sm:w-2/3 sm:pl-8 sm:py-8 sm:border-l border-gray-200 sm:border-t-0 border-t mt-4 pt-4 sm:mt-0 text-center sm:text-left"
          >
            <h3 class="text-2xl mb-2 font-sans font-bold">Storyline</h3>
            <p class="leading-relaxed text-lg mb-4 text-justify">
              Based on a true story about a man named Christopher Gardner.
              Gardner has invested heavily in a device known as a "bone density
              scanner". He feels like he has it made selling these devices.
              However, they do not sell well as they are marginally better than
              x-ray at a much higher price. As Gardner works to make ends meet,
              his wife leaves him and he loses his apartment. Forced to live out
              in the streets with his son, Gardner continues to sell bone
              density scanners while concurrently taking on an unpaid internship
              as a stockbroker, with slim chances for advancement to a paid
              position. Before he can receive pay, he needs to outshine the
              competition through 6 months of training, and to sell his devices
              to stay afloat. <br /><i>Written by John Wiggins, Alf Fonz</i>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="text-gray-600 body-font">
    <div class="container px-5 py-24 mx-auto">
      <div class="flex flex-col text-center w-full mb-20">
        <h1
          class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900"
        >
          Cast &amp; Crew
        </h1>
      </div>
      <div class="flex flex-wrap -m-2">
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://www.biography.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTE4MDAzNDEwNzQzMTY2NDc4/will-smith-9542165-1-402.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/Will_Smith"
                  class="hover:text-red-500"
                  >Will Smith</a
                >
              </h2>
              <p class="text-gray-500">Chris Gardner</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://img.etimg.com/thumb/msid-50447211,width-1200,height-900/magazines/panache/Jaden-Smith-is-the-new-face-of-Louis-Vuitton.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/Jaden_Smith"
                  class="hover:text-red-500"
                  >Jaden Smith</a
                >
              </h2>
              <p class="text-gray-500">Christopher Gardner, Jr.</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://media1.popsugar-assets.com/files/thumbor/kYvzA7CeaOxfLQspCwd8I-xGKLg/0x176:2347x2523/fit-in/2048xorig/filters:format_auto-!!-:strip_icc-!!-/2020/03/17/833/n/1922398/6ba3f44f5e711e6453efb8.38447931_/i/Thandiwe-Newton.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/Thandiwe_Newton"
                  class="hover:text-red-500"
                  >Thandiwe Newton</a
                >
              </h2>
              <p class="text-gray-500">Linda Gardner</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://superstarsbio.com/wp-content/uploads/2020/04/Brian-Howe-495x480.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/Brian_Howe_(actor)"
                  class="hover:text-red-500"
                  >Brian Howe</a
                >
              </h2>
              <p class="text-gray-500">Jay Twistle</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://vz.cnwimg.com/thumb-1200x/wp-content/uploads/2009/12/Dan-Castellaneta-e1510167368461.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/Dan_Castellaneta"
                  class="hover:text-red-500"
                  >Dan Castellaneta</a
                >
              </h2>
              <p class="text-gray-500">Alan Frakesh</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://deadline.com/wp-content/uploads/2018/10/james-karen.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/James_Karen"
                  class="hover:text-red-500"
                  >James Karen</a
                >
              </h2>
              <p class="text-gray-500">Martin Frohm</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://pbs.twimg.com/profile_images/1315576426771501056/yYp7Ewob_400x400.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/Gabriele_Muccino"
                  class="hover:text-red-500"
                  >Gabriele Muccino</a
                >
              </h2>
              <p class="text-gray-500">Director</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://flxt.tmsimg.com/v9/AllPhotos/483791/483791_v9_ba.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/Steven_Conrad"
                  class="hover:text-red-500"
                  >Steve Conrad</a
                >
              </h2>
              <p class="text-gray-500">Writer</p>
            </div>
          </div>
        </div>
        <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
          <div
            class="h-full flex items-center border-gray-200 border p-4 rounded-lg"
          >
            <img
              alt="team"
              class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
              src="https://aurumbureau.com/wp-content/uploads/2020/11/Aurum-Speakers-Bureau-Chris-Gardner.jpg"
            />
            <div class="flex-grow">
              <h2 class="text-gray-900 title-font font-medium">
                <a
                  href="https://en.wikipedia.org/wiki/Chris_Gardner"
                  class="hover:text-red-500"
                  >Chris Gardner</a
                >
              </h2>
              <p class="text-gray-500">Walking Man in Business Suit</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <h1 class="font-bold text-3xl text-gray-700 mb-10">
      THE MESSAGE BEHIND "THE PURSUIT OF HAPPINESS"
    </h1>
  </div>
  <section class="text-gray-600 body-font overflow-hidden bg-blue-200">
    <div class="container px-5 py-24 mx-auto">
      <div class="lg:w-4/5 mx-auto flex flex-wrap">
        <div class="lg:w-1/2 w-full text-center">
          <iframe
            width="445"
            height="300"
            src="https://www.youtube.com/embed/WKRYY6T6Q6k"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
          <h1 class="text-gray-900 text-3xl title-font font-medium mb-1 ">
            Admiring a Car
          </h1>
          <p class="leading-relaxed text-justify">
            On his way to his usual sales calls, he sees a man who pulls up in
            an expensive sports car. The man heads to his office, leaving Chris
            amidst a sea of smiling stock brokers, wondering to himself: “They
            all look so damn happy to me. Why couldn’t I look like that?” That
            thinking is coming from a person who has not gone to a college! And
            we, who have all the necessities of life (luxuries too, for many)
            often get satisfied with as little as a Facebook like. I am not
            saying we need to be greedy, but we must not let mediocrity become
            integral to all parts of our life.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="text-gray-600 body-font overflow-hidden bg-gray-300">
    <div class="container px-5 py-24 mx-auto">
      <div class="lg:w-4/5 mx-auto flex flex-wrap">
        <div class="lg:w-1/2 w-full lg:pr-10 lg:py-6 mt-6 lg:mt-0">
          <h1 class="text-gray-900 text-3xl title-font font-medium mb-1 ">
            Rubik's Cube
          </h1>
          <p class="leading-relaxed text-justify">
            We see that Chris Gardner is now thinking beyond sales. He wants to
            be a stockbroker. But as mentioned earlier, he doesn’t even have a
            college education. So, what can he do to fulfill his new-found
            dream? Chris waits multiple times to have the opportunity to talk to
            Jay who is with the Resource Head of Dean Witter, a stockbroking
            firm. Chris had seen a flyer about an internship offered by the
            firm, whereby he could become a stockbroker. He knew his application
            would not even be considered so he wanted to personally convince the
            man about his potential.
          </p>
        </div>
        <div class="lg:w-1/2 w-full text-center lg:pl-10 lg:py-6 mt-6 lg:mt-0">
          <iframe
            width="445"
            height="300"
            src="https://www.youtube.com/embed/Ogk0D19jsMs"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </section>
  <section class="text-gray-600 body-font overflow-hidden bg-blue-200">
    <div class="container px-5 py-24 mx-auto">
      <div class="lg:w-4/5 mx-auto flex flex-wrap">
        <div class="lg:w-1/2 w-full text-center">
          <iframe
            width="445"
            height="300"
            src="https://www.youtube.com/embed/St7vgJko8Ug"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
          <h1 class="text-gray-900 text-3xl title-font font-medium mb-1 ">
            Arriving at the Interview
          </h1>
          <p class="leading-relaxed text-justify">
            Now Chris finally goes to the interview for the internship but
            arrives in sweatpants and a wife beater, ideally one would be all
            suited up for an occasion like this. The night before this
            interview, Chris’ wife had left him, frustrated by their financial
            problems. Add to that the fact that the landlord wanted to throw
            Chris out but had agreed to let him stay for a week more if Chris
            painted the house, which was what he was doing when the police
            knocked on his door and arrested him for not paying numerous parking
            tickets. He was only released the next morning. And he ran to the
            office for the interview.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="text-gray-600 body-font overflow-hidden bg-gray-300">
    <div class="container px-5 py-24 mx-auto">
      <div class="lg:w-4/5 mx-auto flex flex-wrap">
        <div class="lg:w-1/2 w-full lg:pr-10 lg:py-6 mt-6 lg:mt-0">
          <h1 class="text-gray-900 text-3xl title-font font-medium mb-1 ">
            Htting the Rock Bottom
          </h1>
          <p class="leading-relaxed text-justify">
            Chris just became homeless has now where to go and nowhere to sleep,
            has his son with him and you can just see his freaking out, his son
            tells him that the machine isn’t a time machine to which Chris
            responds that it is. He uses their imagination to travel to a time
            where dinosaurs still roam the earth, and they escape to a cave for
            safety. That cave was a public bathroom where they spend the night,
            that night his son slept in his arms, Chris was covering his ears so
            he didn’t hear the people trying to come in and with one of his legs
            secures the door, so they couldn’t.
          </p>
        </div>
        <div class="lg:w-1/2 w-full text-center lg:pl-10 lg:py-6 mt-6 lg:mt-0">
          <iframe
            width="445"
            height="300"
            src="https://www.youtube.com/embed/o3Zn1lyujwQ"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </section>
  <section class="text-gray-600 body-font overflow-hidden bg-blue-200">
    <div class="container px-5 py-24 mx-auto">
      <div class="lg:w-4/5 mx-auto flex flex-wrap">
        <div class="lg:w-1/2 w-full text-center">
          <iframe
            width="445"
            height="300"
            src="https://www.youtube.com/embed/OdhOqSWe5Qw"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
          <h1 class="text-gray-900 text-3xl title-font font-medium mb-1 ">
            Basketball and Dream
          </h1>
          <p class="leading-relaxed text-justify">
            This is probably the best scene in the movie. It’s a Saturday and
            Chris takes his son to play basketball. He tells his son, that there
            will be things in which he can excel but basketball is not one of
            them. Hearing this, his son is disappointed and starts packing the
            ball. Chris realizes his mistake and says the following words which
            become the soul of the movie:
            <b
              >“Don’t ever let someone tell you, you can’t do something. Not
              even me. You got a dream, you got to protect it. People can’t do
              something themselves, they want to tell you, you can’t do it. You
              want something, go get it. Period. All right?”</b
            >
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="text-gray-600 body-font overflow-hidden bg-gray-300">
    <div class="container px-5 py-24 mx-auto">
      <div class="lg:w-4/5 mx-auto flex flex-wrap">
        <div class="lg:w-1/2 w-full lg:pr-10 lg:py-6 mt-6 lg:mt-0">
          <h1 class="text-gray-900 text-3xl title-font font-medium mb-1 ">
            This is called Happyness
          </h1>
          <p class="leading-relaxed text-justify">
            Even at the lowest point of his life, he maintained the
            illusion that he was just as much a viable candidate as the other
            interns who had homes and all the luxuries of modern-day
            businessmen. He never stopped doubting himself, and confidence is a
            major part of the recipe of success. HAPPYNESS is not money, but
            happiness is seeing your life stable, your child happy, and your
            future bright. Sometimes we need money to make us happy, but it’s
            not the money itself, but what the money brings us, and no one is
            just going to bring us money but you have to go out and achieve it,
            and pursue your own HAPPYNESS.
          </p>
        </div>
        <div class="lg:w-1/2 w-full text-center lg:pl-10 lg:py-6 mt-6 lg:mt-0">
          <iframe
            width="445"
            height="300"
            src="https://www.youtube.com/embed/6Q3uh8TM30U"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </section>
  
  <div id="faq"></div>
</template>

<script>
export default {};
</script>

<style></style>
